"use client"

import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const CreatorProgramBanner = () => {
  return (
    <div className="bg-[#adff13] text-gray-800 py-2 px-4 top-0 z-30">
      <div className="container mx-auto flex items-center justify-center flex-wrap">
        <a href="/creators" className="font-medium text-sm sm:text-base text-center underline flex items-center hover:opacity-80">
          Get paid to make highlights
          <ArrowUpRight className="h-4 w-4 sm:h-5 sm:w-5" />
        </a>
      </div>
    </div>
  );
};

export default CreatorProgramBanner;
